import { Icon, Image } from '@akinon/next/components';
import { useLocalization, useRouter } from '@akinon/next/hooks';
import { Input } from '@theme/components';
import { ROUTES } from '@theme/routes';
import { useState } from 'react';

export const SpecialPageProfile = ({ data, brand, productCount }) => {
  const [searchText, setSearchText] = useState('');
  const { t } = useLocalization();
  const router = useRouter();

  if (!data?.attributes?.profile) return null;

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between px-3 lg:px-0">
      <div className="flex items-center gap-1.5 md:gap-6">
        <div className="rounded-full border-2 border-white w-[100px] h-[100px] md:w-[193px] md:h-[193px]">
          <Image
            src={data?.attributes?.profile?.kwargs?.value?.image?.url}
            alt={brand}
            fill
            aspectRatio={1}
            sizes="(max-width: 640px) 100vw, 530px"
            className="rounded-full"
            imageClassName="rounded-full"
          />
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-xl md:text-3xl font-semibold">{brand}</h1>
            {data?.attributes?.profile?.value?.is_verified === 'true' && (
              <div className="w-5 h-5 bg-[#4f97e9] rounded-full flex items-center justify-center group relative">
                <Icon name="check" size={10} className="text-white" />
                <div className="absolute group-hover:block hidden bg-white py-2 px-3 rounded-lg -left-4 bottom-7 w-[272px] shadow-xl">
                  <div className="absolute w-3 h-3 rotate-45 bg-white -bottom-1 left-5" />
                  <div
                    className="text-[11px]"
                    dangerouslySetInnerHTML={{
                      __html: data?.attributes?.profile?.value?.description
                    }}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="text-sm mt-1.5 md:mt-4">
            {productCount} {t('category.product')}
          </div>
        </div>
      </div>
      <div className="relative px-2 lg:px-0 h-9 mt-5">
        <Input
          placeholder={t('category.search.search_placeholder')}
          className="h-9 border border-gray-900 rounded-sm pl-16"
          wrapperClassName="w-full md:w-[306px]"
          value={searchText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchText(e.target.value)
          }
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter' && searchText.trim() !== '') {
              router.push(`${ROUTES.LIST}/?search_text=${brand} ${searchText}`);
            }
          }}
        />
        <Icon
          name="search"
          size={20}
          className="absolute left-7 top-1/2 -translate-y-1/2 text-gray-1200"
        />
      </div>
    </div>
  );
};
